import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Eye, EyeOff, Lock, User, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import './Login.css';
import logo from '../assets/UNIFAP-1.png';

const Login: React.FC = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: '',
    password: '',
  });

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Login attempt:', formData);
  };

  return (
    <div className="login-page">
      <div className="login-background" />

      <div className="login-container">
        <motion.div
          className="login-card glass"
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <div className="login-header">
            <Link to="/" className="back-link">
              <ArrowLeft size={20} />
              <span>Voltar ao Portal</span>
            </Link>

            <div className="login-logo">
              <div className="logo-icon">
                <img src={logo} alt="Logo UNIFAP" className="logo-icon-logo" />
              </div>
              <div>
                <h1>UNIFAP</h1>
                <p>Portal de Serviços</p>
              </div>
            </div>
          </div>

          <div className="login-content">
            <h2>Acesso ao Sistema</h2>
            <p>Faça login para acessar os serviços da UNIFAP</p>

            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-group">
                <label htmlFor="username">Usuário</label>
                <div className="input-wrapper">
                  <User size={20} />
                  <input
                    type="text"
                    id="username"
                    name="username"
                    value={formData.username}
                    onChange={handleInputChange}
                    placeholder="Digite seu usuário"
                    required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="password">Senha</label>
                <div className="input-wrapper">
                  <Lock size={20} />
                  <input
                    type={showPassword ? 'text' : 'password'}
                    id="password"
                    name="password"
                    value={formData.password}
                    onChange={handleInputChange}
                    placeholder="Digite sua senha"
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowPassword(!showPassword)}
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              <div className="form-options">
                <label className="checkbox-wrapper">
                  <input type="checkbox" />
                  <span className="checkmark"></span>
                  Lembrar de mim
                </label>
                <a href="#" className="forgot-password">
                  Esqueceu a senha?
                </a>
              </div>

              <motion.button
                type="submit"
                className="login-btn"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                Entrar no Sistema
              </motion.button>
            </form>

            <div className="login-divider">
              <span>ou</span>
            </div>

            <div className="login-alternatives">
              <button className="alternative-btn" type="button">
                <span>Área do Aluno</span>
              </button>
              <button className="alternative-btn" type="button">
                <span>Área do Servidor</span>
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Login;
